import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsRouterPluginModule } from '@ngxs/router-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule, NgxsModuleOptions } from '@ngxs/store';
import { environment } from '../../../environments/environment';
import { DataTableState } from '../../store/data-table/data-table.state';
import { AuthState } from '../../store/auth/auth.state';
import { CommonState } from '../../store/home/home.state';


const ngxsMainStates =
  [
    AuthState,
    DataTableState,
    CommonState
  ];
const ngxsStorageStates =
  [
    AuthState,
    DataTableState,
    CommonState
  ];

const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !environment.production,
  selectorOptions: {
    suppressErrors: false,
    injectContainerState: false,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
};

export const ngxsImports = [
  NgxsModule.forRoot(ngxsMainStates, ngxsConfig),
  NgxsStoragePluginModule.forRoot({
    key: ngxsStorageStates,
  }),
  NgxsReduxDevtoolsPluginModule.forRoot({ disabled: environment.production }),
  NgxsFormPluginModule.forRoot(),
  NgxsRouterPluginModule.forRoot(),
];
